import { useCallback, useState } from 'react';
import { findHelpTopicById, type HelpCategory } from './help-center-topics';
import { HelpTopicModal } from './HelpTopicModal';

export type HelpTopicLauncherOptions = {
  /** Arborescence courante (API) pour modale et résolution des liens « Voir aussi ». */
  helpCategories?: readonly HelpCategory[] | null;
};

/**
 * Ouvre la modale d’aide détaillée — partagé entre HelpPage et le chat support.
 */
export function useHelpTopicLauncher(opts?: HelpTopicLauncherOptions) {
  const [selectedTopicId, setSelectedTopicId] = useState<string | null>(null);

  const selectedContext = selectedTopicId
    ? findHelpTopicById(selectedTopicId, opts?.helpCategories ?? null)
    : null;

  const openTopic = useCallback((topicId: string) => {
    setSelectedTopicId(topicId);
  }, []);

  const helpTopicModal = (
    <HelpTopicModal
      open={Boolean(selectedContext)}
      onClose={() => setSelectedTopicId(null)}
      category={selectedContext?.category ?? null}
      topic={selectedContext?.topic ?? null}
      onOpenTopic={openTopic}
      lookupCategories={opts?.helpCategories ?? null}
    />
  );

  return {
    openTopic,
    helpTopicModal,
  };
}
